function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export default function TwitchBrand(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 721 164",
        fill: "currentColor"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M52.4556 45.9201L52.438 0.0808721H0V137.704L26.219 163.919L98.3102 163.928V111.48H52.4556V98.3681H98.3102V45.9201H52.4556Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M242.475 45.92V111.48H229.361V45.92H176.994V111.48H163.88V45.92H111.424V137.704L137.643 163.919L294.931 163.928V45.92H242.475Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M308.044 45.92H360.5V163.919H308.062L308.044 45.92Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M308.062 0.0807915H360.5V32.896H308.044L308.062 0.0807915Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M511.266 45.92L485.038 72.1704V137.704L511.257 163.919L589.949 163.928V111.48H537.494V98.368H589.949V45.92H511.266Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M694.772 45.92H655.519V0.071991H603.063V163.928H655.431V98.368H668.544V163.928L721 163.919V72.1704L694.772 45.92Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M426.069 45.92L426.043 0.0807915L373.614 0.071991V137.704L399.824 163.919H471.924V111.489L426.069 111.48V98.368H471.924V45.92H426.069Z",
                fill: "currentColor"
            })
        ]
    }));
}
